import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../lib/i18n";

export const INSTALL_URL = "https://yoojo.fr/bricolage";
const EASE = [0.16, 1, 0.3, 1];

export const Installation = () => {
  const { t } = useLang();
  return (
    <section id="installation" data-testid="installation-section" className="border-t border-[#E6D9BC]/10">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.15 }}
        className="mx-auto grid max-w-[1440px] items-center gap-12 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12 lg:gap-16"
      >
        <motion.div
          variants={{ hidden: { clipPath: "inset(10% 10% 10% 10% round 32px)" }, show: { clipPath: "inset(0% 0% 0% 0% round 28px)", transition: { duration: 1.4, ease: EASE } } }}
          className="sw-spot relative aspect-[4/5] overflow-hidden rounded-[28px] sm:aspect-[4/3] lg:col-span-5 lg:aspect-[4/5]"
        >
          <img src="/img/installer.jpg" alt={t.installAlt} className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1E2A32]/80 via-transparent to-transparent" />
          <p className="absolute bottom-6 left-6 font-mono text-[11px] uppercase tracking-[0.22em] text-[#E6D9BC]">{t.installTag}</p>
        </motion.div>
        <motion.div
          variants={{ hidden: { opacity: 0, y: 30 }, show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE, delay: 0.2 } } }}
          className="lg:col-span-7"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6D9BC]">{t.installEyebrow}</p>
          <h2 className="mt-6 max-w-2xl font-display text-5xl leading-[1] text-[#F4EFE6] md:text-6xl">
            {t.installTitle[0]}<em className="text-[#E6D9BC]">{t.installTitle[1]}</em>{t.installTitle[2]}
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[#BAC6CE]">{t.installBody}</p>
          <ol className="mt-10 grid gap-px overflow-hidden rounded-2xl border border-[#E6D9BC]/15 bg-[#E6D9BC]/15 sm:grid-cols-3">
            {t.installSteps.map((s, i) => (
              <li key={s} data-testid={`installation-step-${i + 1}`} className="bg-[#1E2A32] p-6 transition-colors duration-500 hover:bg-[#25343E]">
                <span className="font-mono text-sm text-[#E6D9BC]">0{i + 1}</span>
                <p className="mt-6 text-sm leading-relaxed text-[#F4EFE6]">{s}</p>
              </li>
            ))}
          </ol>
          <a data-testid="installation-book-link" href={INSTALL_URL} target="_blank" rel="noopener noreferrer" className="sw-btn group mt-10">
            {t.installCta} <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <p className="mt-4 text-xs text-[#A3B2BC]">{t.installNote}</p>
        </motion.div>
      </motion.div>
    </section>
  );
};
